export default "__VITE_ASSET__95b705d7__"